import React, { useContext, ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { AuthContext } from "../context/Context";

interface PrivateRouteProps {
  children: ReactNode;
  roles?: string[];
  club?: string;
}

const PrivateRoute = ({ children, roles, club }: PrivateRouteProps) => {
  const { slug } = useParams<{ slug: string }>();
  const { isAuthenticated, hasRole } = useContext(AuthContext);

  if (!isAuthenticated) {
    return <Navigate to={`/${slug}/login`} />;
  }
  if (roles && !roles.some((role) => hasRole(role, club))) {
    return <Navigate to={`/${slug}/45/benefits`} />;
  }
  return <>{children}</>;
};

export default PrivateRoute;
